import {useSelector} from "react-redux";
import {tournamentSelectionTournamentIdSelector} from "../components/TournamentSelectionComponent/selectors";
import {userIdSelector} from "../components/System/selectors";
import {getHighscoreApi2, getTournamentApi2} from "../components/System/systemConfig";
import {useQuery} from "@tanstack/react-query";

export function useRootHighscoreLink() {

    const tournamentId = useSelector(tournamentSelectionTournamentIdSelector);
    const userId = useSelector(userIdSelector);

    const highscoreApi = getHighscoreApi2();
    const tournamentApi = getTournamentApi2();

    const myHighscore = useQuery({
        queryKey: ['myHighscore', tournamentId, userId],
        queryFn: () => highscoreApi.getMyTournamentHighscore({tId: String(tournamentId)}),
        enabled: !!tournamentId && !!userId,
    });

    const rootRoundQuery = useQuery({
        queryKey: ['rootRound', tournamentId],
        queryFn: () => tournamentApi.getRootTournamentRoundByType({
            tournamentId: tournamentId!,
            type: 'highscores'
        }),
        enabled: !!tournamentId
    });

    return {
        trId: myHighscore.data?.tournamentRoundId ?? rootRoundQuery.data?.id,
        absolutPos: myHighscore.data?.absolutePos ?? 0,
        isValid: myHighscore.isSuccess || rootRoundQuery.isSuccess
    };
}